// Import model
import { FpRoomCondition } from '../models/FpRoomCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { FpRoomIndexedFields } from '../models/FpRoomIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { FpRoomIndexedFieldsSerializer } from './FpRoomIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FpRoomCondition - handles JSON serialization and deserialization with type validation
 */
export class FpRoomConditionSerializer {
  /**
   * Deserializes a JSON string into a FpRoomCondition instance
   */
  static deserialize(json: string): FpRoomCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FpRoomCondition instance
   */
  static fromObject(obj: any): FpRoomCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FpRoomCondition');
    }


    const instance: FpRoomCondition = {
      fieldName: obj['fieldName'] as FpRoomIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FpRoomCondition instances
   */
  static deserializeArray(json: string): FpRoomCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FpRoomCondition instance to a JSON string
   */
  static serialize(instance: FpRoomCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FpRoomCondition instance to a plain object
   */
  static toObject(instance: FpRoomCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of FpRoomCondition instances to a JSON string
   */
  static serializeArray(instances: FpRoomCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
